import { PropsWithChildren, useContext } from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { CurrentDataContext } from 'src/app/current-data';
import { ClientLinkWrapper } from 'src/router/components';

import WorkspaceIcon from './workspace-icon';

const WorkspaceBreadcrumbs = (
  props: PropsWithChildren<{}>
): JSX.Element | null => {
  const { workspace } = useContext(CurrentDataContext);

  if (!workspace) {
    return null;
  }

  const workspaceIcon = <WorkspaceIcon workspace={workspace} />;
  const workspaceUrl = workspace.links.html.href;

  return (
    <Breadcrumbs>
      <ClientLinkWrapper url={workspaceUrl}>
        <BreadcrumbsItem
          href={workspaceUrl}
          text={workspace.name || ''}
          iconBefore={workspaceIcon}
        />
      </ClientLinkWrapper>
      {props.children}
    </Breadcrumbs>
  );
};

// eslint-disable-next-line import/no-default-export
export default WorkspaceBreadcrumbs;
